import Axios from 'axios';

export default {
    getStreamingEvent(eventId) {
        return Axios.get(`/api/liveinplay/events/${eventId}/fixture/stream`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                this.error = error;
            })
    },

    getStreamingAuthDetails(ip) {
        return Axios.get(`/api/liveinplay/events/auth/${ip}/stream`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                this.error = error;
            })
    }
}